
  import { createApiClient } from 'Network/ApiClient';
  
  export const icdToicdRelationAxiosInstance = createApiClient('relationdiagnoses/');


